import { DataBean } from "../DataBean";

export class UBLFixedDocFactory extends DataBean {



    public async getUBLFixedAssetDocumentFactory(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLFixedAssetDocumentFactory_Number", [id]);
    }

}
